/**
 * ***************************************************************
 * UNOS (Undershoot North / Overshoot South)
 * ***************************************************************
 * Returns compass turn rollout guidance based on latitude
 * and TAS.
 */

/**
 * Convert DMS latitude string to decimal degrees
 * Example: 34-16-01.4451N
 */
export function dmsToDecimal(value) {
  if (!value) return null;

  const s = String(value).trim().toUpperCase();
  const match = s.match(/^(\d+)[- ](\d+)[- ](\d+(?:\.\d+)?)([NS])$/);

  if (!match) return null;

  const deg = Number(match[1]);
  const min = Number(match[2]);
  const sec = Number(match[3]);
  const hemi = match[4];

  let dec = deg + min / 60 + sec / 3600;

  if (hemi === "S") {
    dec *= -1;
  }

  return dec;
}

/**
 * heading: target compass heading
 * lat: latitude as decimal or FAA DMS latitude string
 * tas: true airspeed
 */
export function calculateUNOSRollout(heading, lat, tas = 100) {
  const latitude =
        typeof lat === "number"
            ? lat
            : dmsToDecimal(lat) ?? Number(lat);
  const tasNum = Number(tas);

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(heading) ||
    !Number.isFinite(tasNum) ||
    tasNum <= 0
  ) {
    return {
      amount: "",
      text: "UNOS unavailable"
    };
  }

  // standard-rate turn approximation
  const standardRateTurnDegrees = (tasNum / 10) + 5;
  const lead = 0.5 * standardRateTurnDegrees;

  let amount;

  if (heading === 360 || heading === 0) {
    amount = latitude + lead;

    return {
      amount: Math.round(amount),
      latitude: latitude.toFixed(1),
      turnDegrees: standardRateTurnDegrees.toFixed(1),
      text: `Rollout prior to turning North (360°) by ${Math.round(amount)}°`
    };
  }

  if (heading === 180) {
    amount = latitude - lead;

    return {
      amount: Math.round(amount),
      latitude: latitude.toFixed(1),
      turnDegrees: standardRateTurnDegrees.toFixed(1),
      text: `Rollout after flying through South (180°) by ${Math.round(amount)}°`,
      
    };
  }

  return {
    amount: "",
    text: "UNOS applies to North/South cardinal heading rollout"
  };
}